import React from 'react';

// components
import { PanelBody } from './_panel';

const NoAppointments = function() {
  return (
    <PanelBody className='rep-apts-index__list__container'>
      <div className='rep-apts-index__list__container__row'>
        There are currently no appointments for this month
      </div>
    </PanelBody>
  );
};

export default NoAppointments;



// WEBPACK FOOTER //
// ./app/components/shared/_NoAppointments.jsx